var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found flex-column-center"},[_c('h2',[_vm._v(_vm._s(_vm.$t('notFound')))]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" "+_vm._s(_vm.$t('goHome'))+" "),_c('i',{staticClass:"el-icon-right"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }